import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const RouteBalanceIcon = (props) => {
  const {
    balance,
    className,
    visible,
  } = props;

  if (!visible || balance === 0 || balance == undefined) {
    return null;
  }

  const color = balance > 0 ? "text-danger" : "text-warning";
  const title = (
    balance > 0 ?
    "Route above hours goal" :
    "Route below hours goal"
  );

  return (
    <i
      className={classnames(
        "RouteBalanceIcon",
        "fa fa-circle",
        className,
        color
      )}
      title={title} />
  );
};

RouteBalanceIcon.propTypes = {
  balance: PropTypes.number,
  className: PropTypes.string,
  visible: PropTypes.bool,
};

export default RouteBalanceIcon;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteBalanceIcon.js
 **/